import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FeedbackReporterService } from '../../../../services/feedback-reporter.service';

export interface ErrorDialogData {
  title: string;
  message: string;
  icon?: string;
  showRequestAccess?: boolean;
}

/** Generic modal for displaying error messages with an optional "Retry" action and technical details section. */
@Component({
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.scss'],
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
})
export class ErrorDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<ErrorDialogComponent>>(MatDialogRef);
  data = inject<ErrorDialogData>(MAT_DIALOG_DATA);
  private feedbackReporter = inject(FeedbackReporterService);

  errorTitle: string = '';
  errorDescription: string = '';

  ngOnInit(): void {
    if (this.data && this.data.message) {
      const message = this.data.message.trim();
      const firstSentenceMatch = message.match(/^(.*?[.!?])\s+(.*)$/s);
      if (firstSentenceMatch) {
        this.errorTitle = firstSentenceMatch[1];
        this.errorDescription = firstSentenceMatch[2];
      } else {
        this.errorTitle = message;
        this.errorDescription = '';
      }
    }
  }

  onRequestAccess(): void {
    this.dialogRef.close('request');
  }

  onTryAgain(): void {
    this.dialogRef.close('retry');
  }

  onReturnHome(): void {
    this.dialogRef.close('home');
  }

  onReportProblem(): void {
    this.feedbackReporter.openErrorReport({
      // Generic dialogs may receive a raw backend message. Report the product-authored title and
      // let the user describe what happened rather than copying an exception into diagnostics.
      summary: this.data.title,
      operation: 'error-dialog',
    });
  }
}
